module.exports = __webpack_public_path__ + "img/logo-404.f7d8af21.svg";